var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoothTypeTableTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 229,
    viewBox: "0 0 256 229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.807617 142.986L98.1337 78.6396L255.193 165.933L150.256 228.319L0.807617 142.986Z",
    fill: "#B4E5FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.415 87.1731L101.247 36.665L242.393 117.616L156.829 166.971C155.792 167.548 154.408 167.548 153.255 166.971L14.415 87.1731Z",
    fill: "#0086E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64941 92L14.4152 96.3937V145.859L8.64941 142.032V92Z",
    fill: "#00589D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1808 92L14.415 96.3937V145.859L20.1808 142.032V92Z",
    fill: "#00589D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M144.491 169.528L150.256 173.922V223.245L144.491 219.418V169.528Z",
    fill: "#00589D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M156.022 169.528L150.256 173.922V223.245L156.022 219.418V169.528Z",
    fill: "#00589D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M235.705 116L241.47 120.394V169.859L235.705 166.032V116Z",
    fill: "#00589D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M247.236 116L241.47 120.394V169.859L247.236 166.032V116Z",
    fill: "#00589D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M243.777 125.463L254.155 129.268L247.813 86.3712C247.813 85.1027 247.121 83.9495 246.083 83.2577L102.285 0.691892C100.671 -0.230631 98.5949 -0.230631 96.9805 0.691892L10.1481 51.0847C9.11024 51.6613 8.41835 52.9297 8.41835 54.1982L0.922852 86.8324C0.922852 86.8324 5.53547 94.5586 7.14988 99.2865L12.685 95.1351L150.717 174.011L150.602 175.856C150.602 176.548 150.948 177.24 151.64 177.586L162.364 183.582L161.211 174.587C162.48 174.472 163.979 174.472 165.478 175.279C166.285 175.625 166.285 174.011 165.939 171.359L243.777 125.463Z",
    fill: "#FF9900"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.4144 51.8917L99.0559 3.34393C99.6325 2.99799 100.324 2.99799 100.901 3.34393L240.663 82.4502C241.816 83.1421 241.816 84.8719 240.663 85.5637L156.483 133.535C155.33 134.111 154.061 134.111 152.908 133.535L14.5298 55.0052C13.2613 54.198 13.2613 52.4683 14.4144 51.8917Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M243.777 125.463L246.544 89.6001L248.044 126.847L243.777 125.463Z",
    fill: "#F47500"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M161.211 174.587L156.022 138.378L165.824 171.359C165.939 171.589 166.631 175.741 165.708 175.279C164.671 174.703 162.134 174.357 161.211 174.587Z",
    fill: "#F47500"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M150.717 174.011L153.37 139.647L147.258 172.051L150.717 174.011Z",
    fill: "#F47500"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6843 95.135L10.2627 59.272L17.9888 98.2485L12.6843 95.135Z",
    fill: "#F47500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoothTypeTableTop);
export default __webpack_public_path__ + "static/media/booth-type-table-top.442846b818220ea46004d6418129822e.svg";
export { ForwardRef as ReactComponent };